import { post } from '../axios'

// 工作台权限管理-给模块分配角色
export function v1_portal_role_assign2Module_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/assign2Module`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-批量给用户分配角色
export function v1_portal_role_assign2User_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/role/assign2User`,
    map,
    option
  ).then(response => response)
}

// 获取portal所有的权限
export function v1_portal_getPermissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/getPermissions`,
    map,
    option
  ).then(response => response)
}

// 获取钉钉所有的人员
export function v1_portal_user_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/user/list`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-批量给人员关联角色
export function v1_portal_user_batchRole_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/user/batchRole`,
    map,
    option
  ).then(response => response)
}

// 工作台权限管理-给人员关联角色
export function v1_portal_user_assignRole_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/user/assignRole`,
    map,
    option
  ).then(response => response)
}

// 根据部门名称搜索
export function v1_portal_departmentsByName_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/departmentsByName`,
    map,
    option
  ).then(response => response)
}

// 获取用户访问portal时上报的浏览器信息
export function v1_portal_brower_index_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/brower/index`,
    map,
    option
  ).then(response => response)
}

// 保存用户访问portal时上报的浏览器信息
export function v1_portal_brower_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_V1}/v1/portal/brower/save`,
    map,
    option
  ).then(response => response)
}
